export enum Activity{
    ADD="Add",
    EDIT="Edit",
    DELETE="Delete",
    VIEW="View"
}